import { Box } from '@mui/material';
import Model from '../models/model';


const model = new Model({
	name: 'Indicator',
	defaultSort: 'IndicatorName',
	formTitleField: 'IndicatorName',
	title: 'Indicator Model',
	gridTitle: 'Indicator Model',
	showGridRefreshBtn: true,
	formGroups: [{
		fields: [
			'IndicatorType',
			'ProductName',
			'IndicatorName',
			'ModelName',
			'GTIN'
		]
	}
],
	columns: [
		{ header: 'UniqueId', field: 'IndicatorId', width: 120, hidden: true, maxLength: 50, isNotformfield: true },
		{
			header: 'Model', field: 'ModelName', width: 180, lookup: 'Model', required: true, autocompleteValueFormatter: (newValue, { formik }) => {
				if (newValue) {
					formik.setFieldValue('ModelId', newValue.id, true);
				}
				return newValue.label;
			}
		},
		{ header: 'IndicatorName', field: 'IndicatorName', width: 180, maxLength: 50, required: true },
		{
			header: 'IndicatorType', field: 'IndicatorType', width: 130, lookup: 'IndicatorType', required: true, align: 'left', autocompleteValueFormatter: (newValue, { formik }) => {
				if (newValue) {
					formik.setFieldValue('TypeId', newValue.id, true);
				}
				return newValue.label;
			}
		},
		{ herader: 'Product Name', field: 'ProductName', width: 180, maxLength: 50, required: true },
		{ header: 'UniqueProductIdentifier', field: 'GTIN', width: 220 },
		{ field: 'ModelId', width: 220, excludeOnGrid: true, hideLabel: true, customizeInput: () => <Box /> },
		{ field: 'TypeId', width: 220, excludeOnGrid: true, hideLabel: true, customizeInput: () => <Box /> },

	]
});

export default model.createFormBase();